// Pure helpers for the CRM's "Go live" on a placeholder hosting site
// (components/HostingGoLive.jsx).

// A hosting site still on its build-time placeholder name:
// tmp-*.hosting.squish.internal (shared) or vps-*.squish.internal (VPS).
// Mirrors squish-backend's PLACEHOLDER_RE.
export function isPlaceholderHost(domain) {
  return /\.squish\.internal$/i.test(String(domain || '').trim());
}

// Same rule the backend's setDomainPreflight applies, so the common typo gets a
// field message instead of a round trip: 2+ dot-separated labels of [a-z0-9-],
// and never a placeholder. Strips a pasted scheme, path and leading "www.".
export function normaliseGoLiveDomain(raw) {
  let d = String(raw || '').trim().toLowerCase();
  d = d.replace(/^https?:\/\//, '').split(/[/?#]/)[0].replace(/\.$/, '');
  if (d.startsWith('www.')) d = d.slice(4);
  const labels = d.split('.');
  if (labels.length < 2 || !labels.every((l) => /^[a-z0-9-]+$/.test(l))) {
    return { domain: d, error: 'Enter a domain like example.com.' };
  }
  if (isPlaceholderHost(d)) return { domain: d, error: 'That is a placeholder name, not the customer\'s domain.' };
  return { domain: d, error: '' };
}
